import React from 'react';
import EventEmitter from 'events';
import SelectButton from './buttons/select_button';

const SHOW_MODE_KEY = 'ARES_SHOW_MODE';
const DEFAULT_SHOW_MODE = 'active_files';
const CHANGE_EVENT = 'change';
const SHOW_OPTS = [
  { value: 'all_files', text: 'All' },
  { value: 'active_files', text: 'Active' },
  { value: 'deleted_files', text: 'Deleted' },
];

const g_eventEmitter = new EventEmitter();

let g_showMode = window.localStorage[SHOW_MODE_KEY] || DEFAULT_SHOW_MODE;

function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
  return () => {
    g_eventEmitter.removeListener(CHANGE_EVENT, callback);
  };
}
function _get() {
  return g_showMode;
}
function _setShowMode(new_mode) {
  g_showMode = window.localStorage[SHOW_MODE_KEY] = new_mode;
  _emit('change');
}
export function useShowMode() {
  return React.useSyncExternalStore(_subscribe, _get);
}
export function ShowModeSelect(props) {
  const show_mode = useShowMode();
  return (
    <SelectButton
      style={props.style}
      options={SHOW_OPTS}
      value={show_mode}
      onChange={_setShowMode}
    />
  );
}

export default {
  useShowMode,
  ShowModeSelect,
};
